import { render, staticRenderFns } from "./UpdateEmailRecovery.vue?vue&type=template&id=3c0597ad"
import script from "./UpdateEmailRecovery.vue?vue&type=script&lang=ts"
export * from "./UpdateEmailRecovery.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports